// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oUJ9","label":"styles_label___00w5"};